export default __webpack_public_path__ + "static/media/gallery-error.349263a0.jpg";